namespace $.$$ {

	export class $shm_projects_tests extends $.$shm_projects_tests {

		project() {
			return this.$.$shm_projects_data.detail( this.project_id() )
		}

		index_uri() {
			return this.$.$shm_projects_config.resource_url( 'shm/tests/results/index.json' )
		}

		configured_scenarios() {
			return new Set( this.project()?.tests?.scenarios ?? [] )
		}

		entries() {
			const configured = this.configured_scenarios()
			const entries = ( $shm_tests_app.prototype as any ).entries.call( this ) as readonly $shm_tests_app_index_entry[]
			return entries.filter( entry => configured.has( entry.scenario.id ) )
		}

		menu_links() {
			const scenarios = this.spread_ids_filtered()
			const groups = [ ... ( this as any ).group_ids() ] as string[]
			if( scenarios.some( id => ( this as any ).scenario_group( id ) === 'other' ) ) groups.push( 'other' )
			return groups
				.filter( group => ( this as any ).group_expandable( group ) )
				.map( group => this.Group( group ) )
		}

		spread( next?: string ) {
			const selected = super.spread( next )
			return selected && this.spread_ids().includes( selected ) ? selected : ''
		}

		result_manifest_uri( id: string ) {
			const manifest = this.entries().find( ( entry: $shm_tests_app_index_entry )=> entry.id === id )?.manifest ?? ''
			if( !manifest ) return ''
			const path = manifest.startsWith( 'shm/tests/' )
				? manifest
				: `shm/tests/${ manifest.replace( /^\/+/, '' ) }`
			return this.$.$shm_projects_config.resource_url( path )
		}

		version_tests(): readonly $shm_projects_data_test[] {
			return this.entries().map( ( entry: $shm_tests_app_index_entry )=> ({
				scenario: entry.scenario.id,
				title: this.scenario_title( entry.scenario.id ),
				run: entry.id,
				status: entry.status,
				manifest: entry.manifest,
			}) )
		}

	}

}
